module.exports = __webpack_public_path__ + "static/img/nsfu.d2b489e0.png";